import {
  SALARY_ADJUSTMENT_DATABASE_ROW_KEYS,
  type SalaryAdjustment,
  SalaryAdjustmentDatabaseRowKey,
} from "./adjustSalary.logic";

export function getFirstAvailableSalaryAdjustmentKey(
  adjustments: readonly SalaryAdjustment[],
): SalaryAdjustmentDatabaseRowKey | undefined {
  return SALARY_ADJUSTMENT_DATABASE_ROW_KEYS.find(
    (key) => !adjustments.some((adjustment) => adjustment.key === key),
  );
}
